/**
 *  @class
 *  @function ShopTheLookCustom
 */
if(!customElements.get('shop-the-look-custom')) {
    class ShopTheLookCustom extends HTMLElement {
      constructor() {
        super();     
  
        //this.loadFlickityLibrary();
        this.slideshow = "";
  
        let displayType = (this.querySelector('.diplay-type--grid') !== 'undefined') ? "grid" : "carousel";
        this.isMobile = window.matchMedia("(max-width: 1067px)").matches;
  
        if(this.isMobile && this.classList.contains('swipe-on-mobile')) {   
          this.slideshow = this.querySelector('.shop-the-look-swipeonmobile');   
          this.init();      
        } else if(this.querySelector('.shop-the-look-slideshow')) {
          this.slideshow = this.querySelector('.shop-the-look-slideshow');
        } 
  
        setTimeout(() => {
          if(this.slideshow !== "" && !this.slideshow !== 'undefined') 
          this.init();          
        }, 1000);
        
  
  
        // if(isMobile && this.classList.contains('swipe-on-mobile')) {
        //   this.slideshow = this.querySelector('.is-slideshow-element');
        //   //this.slideshow.classList.add('is-slideshow');
        //   //alert("swipe on mobile")
        // } else if(this.querySelector('shop-the-look-slideshow') !== 'undefined') {
        //   this.slideshow = this.querySelector('shop-the-look-slideshow');        
        //   //alert("slideshow");
        // }
  
        //alert(this.slideshow.classList[0]);     
        
      }    
  
      connectedCallback() {
        //this.loadFlickityLibrary();
        window.addEventListener('resize', (event) => {
          const displayType = this.dataset.displayType;
          window.setTimeout(() => {
            if(this.isMobile) {
              if(displayType == 'carousel' || this.classList.contains('swipe-on-mobile')) {
                this.slideShow = this.querySelector('.shop-the-look-slideshow');
                this.init();
  
                //alert('MOBILE: ' +  this.isMobile + ' ' + this.slideshow.classList[0] + ' DISPLAY TYPE: ' + displayType);
              } else {
                if(this.flickity) this.flickity.destroy();
              }
            }
            else {
              if(displayType == 'carousel' || this.flickity) {
                this.flickity.resize();
                this.flickity.cellAlign = "center";
  
                //alert('MOBILE: ' +  this.isMobile + ' ' + this.slideshow.classList[0] + ' DISPLAY TYPE: ' + displayType);
              } else {
                if(this.flickity) this.flickity.destroy();
              }
            }
            
          },500);
  
          // window.setTimeout(() => {
          //   if(displayType === "carousel") {            
          //     this.slideShow = this.querySelector('.shop-the-look-slideshow');
          //     this.init();            
          //   } else {
          //     if(this.isMobile && this.classList.contains('swipe-on-mobile')) {
          //       this.slideShow = this.querySelector('.shop-the-look-swipeonmobile');
          //       this.init();
          //     } else {
          //       if(this.flickity) this.flickity.destroy();
          //     }        
          //   } 
  
          //   alert('MOBILE: ' +  this.isMobile + ' ' + this.slideshow.classList[0] + ' DISPLAY TYPE: ' + displayType);
            
          //   console.log(this.slideshow.classList[0]); 
  
          //   let flktyData = Flickity.data(this.flickity);
          //   console.log(flktyData);
  
          // }, 500);
        });
      }
  
      // loadFlickityLibrary() {
      //   const waitForLibrary = setInterval(() => {
      //     if (typeof Flickity !== 'undefined') {
      //       clearInterval(waitForLibrary);
      //       // Your code that depends on the library
      //       this.init();
      //     }
      //   }, 100); // Check every 100ms  
      // }
  
  
      init() {
        console.log("Begin initialize shop the look...");
        let
          parent_section = this.closest('.shopify-section'),
          slideshow_slides = Array.from(this.slideshow.querySelectorAll('.carousel__slide, shop-the-look-image')),
          cell_align = this.slideshow.dataset.align,
          pageDots = this.slideshow.dataset.dots,
          prev_button = this.slideshow.querySelector('.flickity-prev'),
          next_button = this.slideshow.querySelector('.flickity-next'),        
          animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
          //selectedIndex = 0;
        
        const isMobile = window.matchMedia("(max-width: 767px)");
        if(isMobile.matches && this.classList.contains('swipe-on-mobile')) {
          cell_align = 'center';
        }
  
        // alert(cell_align);
  
               
        this.options = {
          wrapAround: false,
          contain: true,
          groupCells: false,
          // cellAlign: cell_align,
          cellAlign: cell_align,
          pageDots: pageDots,        
          prevNextButtons: false,
          cellSelector: '.carousel__slide'
        };
  
        // Initiate
        this.flickity = new Flickity(this.slideshow, this.options);          
        
        
  
        //selectedIndex = this.flickity.selectedIndex;
  
        this.slideshow.dataset.initiated = true;
          
        if (next_button) {
          window.addEventListener('.flickity-resize.center_arrows', function () {
            this.centerArrows(prev_button, next_button);
          });
        }
        window.dispatchEvent(new Event('.flickity-resize.center_arrows'));
  
        // Arrows
        if (prev_button) {
          prev_button.addEventListener('click', (event) => {
            this.flickity.previous();
          });
          prev_button.addEventListener('keyup', (event) => {
            this.flickity.previous();
          });
          next_button.addEventListener('click', (event) => {
            this.flickity.next();
          });
          next_button.addEventListener('keyup', (event) => {
            this.flickity.next();
          });
        }
  
        this.style.setProperty('--flickity-viewport-offsetheight', this.querySelector('.flickity-viewport').offsetHeight + 'px');
        
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            let index = slideshow_slides.indexOf(event.target);
            this.flickity.select(index);
          });
        }         
        console.log("Shop the look successfully initialized...");     
      }
  
  
      centerArrows(prev_button, next_button) {
        let first_cell = this.flickity.cells[0],            
            max_height = 0, 
            image_height = 0;
  
        if (first_cell.element.querySelector('shop-the-look-custom--image')) {
          image_height = first_cell.element.querySelector('.photoswipe__image').clientHeight;
        } 
        
        if (image_height > 0) {
          this.flickity.cells.forEach((item, i) => {
            if (item.size.height > max_height) {
              max_height = item.size.height;
            }
          });
  
          if (max_height > image_height) {
            let difference = (max_height - image_height) / -2;
            prev_button.style.transform = 'translateY(' + difference + 'px)';
            next_button.style.transform = 'translateY(' + difference + 'px)';
          }
        }
      }
    }
    customElements.define('shop-the-look-custom', ShopTheLookCustom);
  }
  
  
  /**
   *  @class
   *  @function ShopTheLookCustomSlideShow
   */
  // if (!customElements.get('shop-the-look-slideshow')) {
  //   class ShopTheLookCustomSlideShow extends HTMLElement {
  //     constructor() {
  //       super();
  
  //       this.loadFlickityLibrary();
  
  //       // const waitForLibrary = setInterval(() => {
  //       //   if (typeof Flickity !== 'undefined') {
  //       //     clearInterval(waitForLibrary);
  //       //     // Your code that depends on the library
  //       //     //this.flickity = new Flickity(this, options);
  //       //     console.log("FLICKITY WAS LOADED...")
  //       //     this.init();
  //       //     // this.addEventListener('change', this.setupImageSlider());
  //       //     //selectedIndex = this.flickity.selectedIndex;
  
  //       //     //this.dataset.initiated = true;
  //       //   }
  //       // }, 100); // Check every 100ms      
  
  //       // Theme editor     
  
  //       //this.init();
  
  //     }
  
  //     connectedCallback() {
  //       this.loadFlickityLibrary();
  //     } 
  
  //     loadFlickityLibrary() {
  //       const waitForLibrary = setInterval(() => {
  //         if (typeof Flickity !== 'undefined') {
  //           clearInterval(waitForLibrary);
  //           // Your code that depends on the library
  //           this.init();
  //         }
  //       }, 100); // Check every 100ms  
  //     }
  
  
  //     init() {
  //       console.log("Begin initialize shop the look...");
  //       let
  //         parent_section = this.closest('.shopify-section'),
  //         dots = this.dataset.dots === 'true',
  //         slideshow_slides = Array.from(this.querySelectorAll('.carousel__slide')),
  //         autoplay = this.dataset.autoplay == 'false' ? false : parseInt(this.dataset.autoplay, 10),
  //         align = this.dataset.align == 'center' ? 'center' : 'left',
  //         fade = this.dataset.fade == 'true' ? true : false,
  //         pageDots = this.dataset.dots == 'true' ? true : false,
  //         prev_button = this.querySelector('.flickity-prev'),
  //         next_button = this.querySelector('.flickity-next'),
  //         custom_dots = this.querySelector('.flickity-custom-dots'),
  //         custom_navigation = this.querySelector('.flickity-custom-navigation'),
  //         autoplay_progress = this.querySelector('.slideshow--autoplay-progress'),
  //         progress_bar = this.parentNode.querySelector('.flickity-progress--bar'),
  //         animations = [],
  //         cell_align = align,
  //         animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
  //         selectedIndex = 0;
        
  //       const isMobile = window.matchMedia("(max-width: 767px)");
  //       if(isMobile and this.classList.contains('swipe-on-mobile')) {
  //         cell_align = 'center';
  //       }
          
  //       this.options = {
  //         cellAlign: cell_align,
  //         pageDots: pageDots,
  //         contain: true,        
  //         prevNextButtons: false,
  //         cellSelector: '.carousel__slide'
  //       };
  
  //       // Initiate
  //       this.flickity = new Flickity(this, this.options);
  
  //       selectedIndex = this.flickity.selectedIndex;
  
  //       this.dataset.initiated = true;      
  
  //       this.options.on = {
  //         ready: function () {
  //           if (next_button) {
  //             window.addEventListener('resize.center_arrows', function () {
  //               slideshow.centerArrows(prev_button, next_button);
  //             });
  //           }
  //           window.dispatchEvent(new Event('resize.center_arrows'));
  
  //           // Arrows
  //           if (prev_button) {
  //             prev_button.addEventListener('click', (event) => {
  //               this.flickity.previous();
  //             });
  //             prev_button.addEventListener('keyup', (event) => {
  //               this.flickity.previous();
  //             });
  //             next_button.addEventListener('click', (event) => {
  //               this.flickity.next();
  //             });
  //             next_button.addEventListener('keyup', (event) => {
  //               this.flickity.next();
  //             });
  //           }
  //         }
  //       }
  
  //       if (Shopify.designMode) {
  //         this.addEventListener('shopify:block:select', (event) => {
  //           let index = slideshow_slides.indexOf(event.target);
  //           this.flickity.select(index);
  //         });
  //       }     
  
  //       // this.flickity.on('ready', (event) => {
  //       //   if (!this.flickity.cells.length > 0) return;
  //       //   let length = this.flickity.cells.length,
  //       //       cells = this.flickity.cells,
  //       //       tallest = cells[0].offsetHeight;
          
  //       //   cells.forEach((cell,index) => {
  //       //     if (cell.offsetHeight > tallest) {
  //       //       tallest = cell.offsetHeight;
  //       //     }
  //       //   });
  //       //   document.documentElement.style.setProperty('--shop-the-look-cell-height', tallest);        
  //       // });
  //       console.log("Shop the look successfully initialized...");
  //     }
  
  
  //     centerArrows(prev_button, next_button) {
  //       let first_cell = this.flickity.cells[0], 
  //           max_height = 0, 
  //           image_height = 0;
  
  //       if (first_cell.element.querySelector('shop-the-look-custom--image')) {
  //         image_height = first_cell.element.querySelector('.photoswipe__image').clientHeight;
  //       } 
        
  //       if (image_height > 0) {
  //         this.flickity.cells.forEach((item, i) => {
  //           if (item.size.height > max_height) {
  //             max_height = item.size.height;
  //           }
  //         });
  
  //         if (max_height > image_height) {
  //           let difference = (max_height - image_height) / -2;
  
  //           prev_button.style.transform = 'translateY(' + difference + 'px)';
  //           next_button.style.transform = 'translateY(' + difference + 'px)';
  //         }
  //       }
  
  //     }
  //   }
  //   customElements.define('shop-the-look-slideshow', ShopTheLookCustomSlideShow);
  // }
  
  // ******************************************************************************
  
  // document.addEventListener("DOMContentLoaded", (event) => {
  //   let shopTheLookCustom = document.querySelector('shop-the-look-custom');
  //   let shopTheLookSlideShow = shopTheLookCustom.querySelector('.shop-the-look-slideshow');
  
  //   slideShowOptions = {
  //     wrapAround: true,
  //     cellAlign: shopTheLookSlideShow.dataset.align,
  //     pageDots: shopTheLookSlideShow.dataset.dots,
  //     contain: true,        
  //     prevNextButtons: false,
  //     cellSelector: 'shop-the-look-image.carousel__slide',
  //     on: {}
  //   }
  
  //   let flkty = new Flickity(shopTheLookSlideShow, slideShowOptions);
  
  //   shopTheLookSlideShow.dataset.initiated = true;
  
  //   flkty.on('ready', function(){
  //     let prev_button = shopTheLookSlideShow.querySelector('.flickity-prev');
  //     let next_button = shopTheLookSlideShow.querySelector('.flickity-next');
  
  //     if (prev_button) {
  //       prev_button.addEventListener('click', (event) => {
  //         flkty.previous();
  //       });
  //       prev_button.addEventListener('keyup', (event) => {
  //         flkty.previous();
  //       });
  //       next_button.addEventListener('click', (event) => {
  //         flkty.next();
  //       });
  //       next_button.addEventListener('keyup', (event) => {
  //         flkty.next();
  //       });
  //     }
  //   });
      
  // });
  
  
  document.addEventListener("DOMContentLoaded", (event) => {
    let shopTheLookCustom = document.querySelector('.shop-the-look-custom'); 
    let closeButtons = Array.from(shopTheLookCustom.querySelectorAll('.close-hotspot-info'));
  
    closeButtons.forEach((closeButton, index) => {
      closeButton.addEventListener('click', (event) => {
        event.target.closest('.hotspot--inner').classList.remove('active');
      });
    });
  
  
    shopTheLookCustom.addEventListener('click', (event) => {
      //alert(event.target.classList[1]);
     if(!event.target.classList.contains('thb-hotspot-content')) return;
  
      let parentHotspot = event.target.closest('.shop-the-look__hotspot');
      let parentImage = event.target.closest('.shop-the-look-custom--image');
      
      if(event.target.classList.contains('thb-hotspot-content')) {
        if(event.target.parentElement.classList.contains('active')) {
          event.target.parentElement.classList.remove('active');
        } else {
          parentImage.querySelector('.active')?.classList.remove('active');
          event.target.parentElement.classList.add('active');
        }
      }
    });
  });
  
  